export enum PolicyType {
    TERMS_OF_SERVICE = 1,
    PRIVACY_POLICY = 2,
    PAYMENT_POLICY = 3,
    REFUND_POLICY = 4,
    EULA_POLICY = 5
}

export const policyTypePopupIdMap: Map<PolicyType, string> = new Map([
    [PolicyType.TERMS_OF_SERVICE, 'terms_of_service'],
    [PolicyType.PRIVACY_POLICY, 'privacy_policy'],
    [PolicyType.PAYMENT_POLICY, 'payment_policy'],
    [PolicyType.REFUND_POLICY, 'refund_policy'],
    [PolicyType.EULA_POLICY, 'eula_policy']
]);
